import { ButtonGroup } from "../../components/ButtonGroup"
import { Checkbox } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES_PATH } from "../../utils/constants";
import { BankreaderService } from "../../services/Bankreader";
import { useDispatch, useSelector } from "react-redux";
import { ConsentType } from "../../models/ConsentType";
import { IRootState } from "../../redux/store";
import { isLoading } from "../../redux/loaderSlice";
import { showModal } from "../../redux/modalSlice";
import { StorageService } from "../../services/Storage";
import { WebsocketCode } from "../../models/Websocket";
import { selectFlowStep } from "../../redux/headerSlice";
import { saveRequest } from "../../redux/requestSlice";

export const Entry: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [conditionsAccepted, setConditionsAccepted] = useState<boolean>(false);
  const bankreaderId = useSelector((state: IRootState) => state.request.value.data.bankreader_id);
  const thirdParty = useSelector((state: IRootState) => state.request.value.data.third_party);
  const defaultBank = useSelector((state: IRootState) => state.request.value.isDefaultBank);
  const [legalName, setLegalName] = useState<string>();
  const [termsDocument, setTermsDocument] = useState<string | undefined>(process.env.REACT_APP_TINK_DOCUMENT);

  const nextPage = async () => {
    const navigatorData = window.navigator;
    const consentBody: ConsentType = {
      token: StorageService.getPepperStore().accessToken,

      navigator: {
        platform: navigatorData.platform,
        app_version: navigatorData.appVersion,
        user_agent: navigator.userAgent
      }
    }
    dispatch(isLoading(true));
    if (bankreaderId) {
      BankreaderService.getConsent(bankreaderId, consentBody)
        .then(() => {
          BankreaderService.sendWebsocketCode(bankreaderId, { code: WebsocketCode.TERMS_ACCEPTED })
          if (defaultBank || process.env.REACT_APP_ENV === 'development') {
            dispatch(isLoading(true));
            BankreaderService.sendWebsocketCode(bankreaderId, { code: WebsocketCode.BANK_SELECTED })
            navigate(ROUTES_PATH.LOGIN)
          } else {
            navigate(ROUTES_PATH.ENTITIES);
          }
        })
        .catch(() => {
          navigate(ROUTES_PATH.UNKNOWN_ERROR);
        });
    } else {
      navigate(ROUTES_PATH.ENTITIES);
    }
  }

  useEffect(() => {
    if (thirdParty === 'UNAX') {
      setLegalName('UNNAX REGULATORY SERVICES, E.D.E., S.L.');
    } else {
      setLegalName('Tink AB');
      setTermsDocument(process.env.REACT_APP_TINK_DOCUMENT);
    }
  }, [thirdParty]);


  useEffect(() => {
    const bankreaderStored = StorageService.getBankreaderStore();
    dispatch(selectFlowStep(null));
    if (bankreaderId) {
      dispatch(isLoading(false));
    } else if(bankreaderStored) {
      dispatch(saveRequest(bankreaderStored));
      dispatch(isLoading(false));
    } else {
      navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  }, [bankreaderId]);

  return (
    <div className='entry-container'>
      <div className='entry-container-img'></div>
      <div className='entry-container-text'>
        <div className="pepper-title">
          Servicio de agregación financiera:
        </div>
        <p>Es importante que antes de continuar con el proceso, aceptes los términos y condiciones del servicio de agregación de cuentas que {legalName},
          está dispuesto a prestarle con la finalidad de ayudar a
          <span className='pepper-text-bold'> Pepper </span>
          a evaluar su solicitud financiera de forma rápida y segura.</p>
        <Checkbox className='conditions-checkbox' onChange={() => setConditionsAccepted(!conditionsAccepted)}>
          <div className="checkbox-text">Acepto los <a className='pepper-link' href={termsDocument} target='_blank'>términos y condiciones</a> del servicio</div>
        </Checkbox>
      </div>
      <div className='buttons-wrapper'>
      <ButtonGroup handleOk={nextPage} handleCancel={() => dispatch(showModal(true))} continueMsg="Acceder" continueDisabled={!conditionsAccepted} />
      </div>
    </div>
  )
}
